import { useState } from "react";
import { useTranslation } from "react-i18next";

export const ButtonLanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    setIsOpen(false);
  };

  const currentLanguage = i18n.language === "fr" ? "FR" : "BR";

  return (
    <div className="relative">
      <button
        onClick={toggleDropdown}
        className="btn-primary bg-transparent hover:bg-dark"
      >
        {currentLanguage}
      </button>

      {isOpen && (
        <div className="absolute btn-primary text-white hover:bg-dark">
          <ul>
            <li>
              <button
                onClick={() => changeLanguage("fr")}
                className="block p-1 hover:bg-gray-600 w-full text-left"
              >
                Français
              </button>
            </li>
            <li>
              <button
                onClick={() => changeLanguage("br")}
                className="block p-1 hover:bg-gray-600 w-full text-left"
              >
                brezhoneg
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};
